import { Box, Paper } from '@mui/material';
import classNames from 'classnames';
import moment from 'moment';
import { ReactNode } from 'react';

import { useSxStyles } from './useStyles';

export type ProcessItemProps = {
  itemBadge: ReactNode;
  children?: ReactNode;
  isFirstItem?: boolean;
  isLastItem?: boolean;
  status?: ReactNode;
  statusColor?:
    | 'default'
    | 'success'
    | 'warning'
    | 'error'
    | 'info'
    | 'disabled';
  timestamp?: Date;
};

export const ProcessItem = (props: ProcessItemProps) => {
  const {
    isFirstItem,
    isLastItem,
    itemBadge,
    children,
    timestamp,
    status,
    statusColor,
  } = props;
  const sxStyles = useSxStyles();

  return (
    <Box
      sx={sxStyles.processItem}
      className={classNames(isFirstItem && 'first', isLastItem && 'last')}
    >
      <Box className={'badge'}>{itemBadge}</Box>
      <Paper className={'info'}>
        <Box sx={sxStyles.processStatus}>
          {status && (
            <Box className={classNames('status', statusColor)}>{status}</Box>
          )}
          {timestamp && (
            <Box className={'timestamp'}>
              {moment(timestamp).format('L LT')}
            </Box>
          )}
        </Box>
        {children}
      </Paper>
      <Box className={'buffer'}></Box>
    </Box>
  );
};
